import { EProjectPropertyType } from '../enums/project-type.enum';
import { EProjectTransactionPropertyType } from '../enums/project-transaction.enum';
import { OptionDescription } from './option.type';

export type ProjectTransactionPropertyTypeRecord = Record<EProjectTransactionPropertyType, OptionDescription<EProjectTransactionPropertyType>>;
export type ProjectPropertyTypeRecord = Record<EProjectPropertyType, OptionDescription<EProjectPropertyType>>;
